import { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { Link } from "react-router-dom";
import { ReactComponent as ChevronRight } from "../../../../assets/img/icon/chevron_right_black_24dp.svg";
import { ReactComponent as Description } from "../../../../assets/img/icon/description_black_24dp.svg";
import { ReactComponent as FemaleIcon } from "../../../../assets/img/icon/female_black_24dp.svg";
import { ReactComponent as MaleIcon } from "../../../../assets/img/icon/male_black_24dp.svg";
import { ReactComponent as MaskIcon } from "../../../../assets/img/icon/masks_black_24dp.svg";
import { ReactComponent as PersonIcon } from "../../../../assets/img/icon/person_black_24dp.svg";
import { ReactComponent as PlayIcon } from "../../../../assets/img/icon/play_arrow_black_24dp.svg";
import { ReactComponent as SensorIcon } from "../../../../assets/img/icon/sensors_black_24dp.svg";
import { ReactComponent as StopIcon } from "../../../../assets/img/icon/stop_black_24dp.svg";
import { ReactComponent as WifiOff } from "../../../../assets/img/icon/wifi_off_black_24dp.svg";
import { COLOR } from "../../../../config/constant";
import { getDateFormat2, getDuration } from "../../../../helpers/helper";
import {
  getDeviceDetail,
  postControlDevice,
} from "../../../../services/httpService/deviceRequest";
import { getRecord } from "../../../../services/httpService/recordRequest";
import { client } from "../../../../services/mqttService/mqttService";
import { GlobalContext } from "../../../contexts/globalContext";
import AnimatedBlock from "../../../ui/atoms/AnimatedBlock/AnimatedBlock";
import BlinkAlert from "../../../ui/atoms/BlinkAlert/BlinkAlert";
import Button from "../../../ui/atoms/Button/Button";
import CardDashboard from "../../../ui/atoms/CardDashboard/CardDashboard";
import ChartLine from "../../../ui/atoms/ChartLine/ChartLine";
import DeviceInfo from "../../../ui/atoms/DeviceInfo/DeviceInfo";
import PageTitle from "../../../ui/atoms/PageTitle/PageTitle";
import ModalDeviceUse from "../../../ui/organisms/ModalDeviceUse/ModalDeviceUse";

const PARAMS = {
  BASIC: [
    { label: "Resp Rate", key: "RR", unit: "" },
    { label: "SpO2", key: "SPO2", unit: "%" },
    { label: "Temperatur", key: "T", unit: "celcius" },
    { label: "Heart Rate", key: "HR", unit: "BPM" },
  ],
};

const LIMIT = 10;
let TOPIC;
let intervalId;
let durationJob;

const DeviceDetail = () => {
  const isMounted = useRef(true);
  const [sharedState, dispatch] = useContext(GlobalContext);
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const [device, setDevice] = useState("");
  const [records, setRecords] = useState(new Array(5).fill(0));
  const [modal, setModal] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [state, setState] = useState({
    isRun: false,
    isReady: false,
    lastMessage: new Date(1),
  });

  const [duration, setDuration] = useState({
    firstFire: "",
    show: "",
  });

  const [showGraph, setShowGraph] = useState(false);

  const handleGetDevice = async () => {
    try {
      const { result } = await getDeviceDetail(params.id);
      if (result.doctor && result.doctor.isRequestUser === true) {
        TOPIC = result._id;
        client.subscribe(result._id);
        client.subscribe(`${result._id}/state`, { qos: 1 });
        client.on("message", (topic, message) => {
          message = message.toString();
          if (topic === result._id) {
            let { payload } = JSON.parse(message);
            if (!payload) return;
            let updatedValue = {
              RR: payload.RR ? payload.RR : "",
              SPO2: payload.SPO2 ? payload.SPO2 : "",
              T: payload.T ? payload.T : "",
              HR: payload.HR ? payload.HR : "",
            };
            if (!isMounted.current) return;
            setState((prevState) => ({
              ...prevState,
              isReady: true,
              lastMessage: new Date(),
            }));
            setValue(updatedValue);
            setData((prevState) => {
              updatedValue["idx"] =
                prevState.length === 0
                  ? 1
                  : prevState[prevState.length - 1].idx + 1;
              prevState = [...prevState, updatedValue];
              if (prevState.length > LIMIT) prevState.shift();
              return prevState;
            });
          } else if (topic === `${result._id}/state`) {
            message = JSON.parse(message);
            if (!isMounted.current) return null;
            const updatedValue = {
              isRun: message.state === "running" ? true : false,
              isReady: true,
              lastMessage: new Date(),
            };
            setState((prevState) => ({ ...prevState, ...updatedValue }));
            setDevice((prevState) => {
              let updatedDevice = { ...prevState };
              updatedDevice["isReady"] = true;
              return updatedDevice;
            });
          }
        });
        client.publish(`${result._id}/cmd`, JSON.stringify({ cmd: "state" }), {
          qos: 2,
        });
      } else if (result.doctor && result.doctor.isRequestUser === false) {
        if (isMounted.current)
          dispatch("alert", {
            message:
              "Perangkat terhubung oleh pengguna lain. Tekan tombol pada perangkat untuk mengatur ulang.",
            type: "warning",
            show: true,
          });
      }

      if (!result.patient && isMounted.current) {
        dispatch("alert", {
          message: "Klik gunakan perangkat untuk memilih pasien.",
          show: true,
          type: "warning",
        });
      }
      if (!isMounted.current) return null;
      setState((prevState) => ({
        ...prevState,
        isRun: result.isRun,
      }));
      setDevice(result);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        dispatch("alert", {
          show: true,
          message: `Perangkat "${params.id}" tidak ditemukan`,
          type: "warning",
        });

        history.push("/device");
      }
    }
  };

  const handleGetRecord = async () => {
    try {
      let { result } = await getRecord(
        `limit=5&fields=patient,createdAt,testNumber&device=${params.id}`
      );
      result.forEach((res) => {
        res["createdAt"] = getDateFormat2(res["createdAt"], true);
      });
      if (isMounted.current) setRecords(result);
      if (sharedState.isLoading === true) dispatch("isLoading", false);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleAction = async (input) => {
    try {
      dispatch("isLoading", true);
      await postControlDevice({
        _id: device._id,
        action: input,
      });
      dispatch("isLoading", false);
      switch (input) {
        case "stop":
          handleGetRecord();
          setDuration((prevState) => ({ ...prevState, firstFire: "" }));
          break;
        case "start":
          setData([]);
          setDuration({ firstFire: new Date(), duration: "00:00" });
          break;
        default:
          break;
      }
    } catch (error) {
      let newState;
      let message;
      switch (error.message) {
        case "device already started":
          newState = true;
          message = "perangkat sudah berjalan";
          break;
        case "device already stopped":
          newState = false;
          message = "perangkat sudah berhenti";
          break;
        default:
          message = error.message;
          break;
      }

      if (newState != undefined)
        setState((prevState) => ({ ...prevState, isRun: newState }));
      dispatch("isLoading", false);
      dispatch("alert", {
        show: true,
        message: message,
        type: "warning",
      });
    }
  };

  const forcedClose = async () => {
    try {
      setDuration((prevState) => ({ ...prevState, firstFire: "" }));
      await postControlDevice({
        _id: device._id,
        action: "stop",
      });
      handleGetRecord();
      setState((prevState) => ({ ...prevState, isRun: false }));
      dispatch("alert", {
        show: true,
        message: "Terjadi kesalahan jaringan. Pengukuran dihentikan.",
        type: "warning",
      });
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    handleGetDevice();
    handleGetRecord();
    return () => {
      client.unsubscribe(`${TOPIC}/state`);
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (state.isRun === true && device.doctor?.isRequestUser) {
      intervalId = setInterval(() => {
        let diffSecond = (new Date() - state.lastMessage) / 1000;
        // SET WARNING
        if (diffSecond > 14) {
          setState((prevState) => ({ ...prevState, isReady: false }));
        }
        if (diffSecond > 21) {
          clearInterval(intervalId);
          forcedClose();
        }
      }, 4000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [state.isRun, state.lastMessage]);

  useEffect(() => {
    if (duration.firstFire != "") {
      durationJob = setInterval(() => {
        setDuration((prevState) => ({
          ...prevState,
          show: getDuration(prevState.firstFire),
        }));
      }, 1000);
    }
    return () => {
      clearInterval(durationJob);
    };
  }, [duration]);
  return (
    <>
      <ModalDeviceUse
        show={modal}
        _id={device._id}
        handleClose={() => {
          setModal(false);
        }}
        handleUpdate={handleGetDevice}
      />
      <BlinkAlert
        show={state.isRun && !state.isReady && device.doctor?.isRequestUser}
      />
      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Perangkat"
          description="Kendalikan perangkat respinos yang anda miliki, kemudian lihat hasilnya di halaman rekam medis."
          icon={
            <MaskIcon className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />
        <DeviceInfo
          device={device}
          className="mt-6"
          handleClick={() => {
            setModal(true);
          }}
        />
        {/* SUBMENU */}
        <div className="mt-10 flex justify-end items-center">
          {/* RIGHT SUBMENU */}
          <div className="w-full xl:w-1/3 flex space-x-3 justify-end mt-3 xl:mt-0">
            <Link to="/device">
              <div className="text-primary cursor-pointer flex items-center ">
                <div>
                  <ChevronRight fill={COLOR.PRIMARY} className="w-6 h-6" />
                </div>
                <div className="ml-1 border-b border-transparent hover:border-primary">
                  Kembali
                </div>
              </div>
            </Link>
          </div>
        </div>

        {device.doctor && device.doctor.isRequestUser && (
          <div className="mt-5 grid grid-cols-12 gap-5">
            <div className="col-span-12 lg:col-span-8">
              <CardDashboard
                icon={<SensorIcon fill={"#fafafa"} className="w-5 h-5" />}
                title="Monitoring Sensor"
                className="bg-primary absolute "
              >
                <div className="flex space-x-3 mt-5 items-center">
                  <div className="flex w-full bg-success border border-white text-white shadow-lg px-1.5 md:px-3 py-2 rounded-xl items-center space-x-1 sm:space-x-2  relative">
                    <div className="">
                      <PersonIcon className="w-10 sm:w-14 md:w-16 h-10 sm:h-14 md:h-16 fill-current text-white" />
                    </div>
                    {device.patient && (
                      <>
                        <div className="">
                          <div className="text-base md:text-lg xl:text-xl">
                            {device.patient.user.name}
                          </div>
                          <div className="text-white text-opacity-70 text-xs md:text-sm">
                            {device.patient.user.profile.age
                              ? `${device.patient.user.profile.age} Tahun |`
                              : ""}
                            {`${
                              device.patient.user.profile.weight || "-"
                            } Kg | ${
                              device.patient.user.profile.height || "-"
                            } cm`}
                          </div>
                        </div>

                        <div className="absolute top-4 right-2 hidden md:block">
                          {device.patient.user.profile.isMale === true && (
                            <MaleIcon className="w-8 sm:w-12 h-10 sm:h-12 fill-current text-white text-opacity-70" />
                          )}
                          {device.patient.user.profile.isMale === false && (
                            <FemaleIcon className="w-8 sm:w-12 h-10 sm:h-12 fill-current text-white text-opacity-70" />
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  {!state.isReady ? (
                    <div
                      className={
                        "w-24 flex-shrink-0 border border-white bg-gray-500 rounded-xl shadow-lg px-2 py-2 md:py-4"
                      }
                      // style={{ height: "5rem" }}
                    >
                      <div className="text-center text-white tracking-wider leading-tight">
                        <WifiOff className="mx-auto w-6 sm:w-8 h-6 sm:h-8 fill-current text-white" />
                        <div className="mt-1 text-xs">Offline</div>
                      </div>
                    </div>
                  ) : state.isRun ? (
                    <button
                      className={
                        "w-24 flex-shrink-0 border border-white bg-red-500 rounded-xl shadow-lg p-2 hover:bg-opacity-80 focus:outline-none focus:ring-2 cursor-pointer"
                      }
                      // style={{ height: "5rem" }}
                      onClick={() => handleAction("stop")}
                      disabled={sharedState.isLoading}
                    >
                      <div className="text-center text-white uppercase tracking-wider">
                        <StopIcon className="mx-auto w-8 sm:w-10 h-8 sm:h-10 fill-current text-white" />
                        <div className="mt-1 text-xs">Stop</div>
                      </div>
                    </button>
                  ) : (
                    <button
                      className={
                        "w-24 flex-shrink-0 border border-white bg-indigo-500 rounded-xl shadow-lg p-1 md:p-2 hover:bg-opacity-80 focus:outline-none focus:ring-2 cursor-pointer"
                      }
                      // style={{ height: "5rem" }}
                      onClick={() => handleAction("start")}
                      disabled={sharedState.isLoading}
                    >
                      <div className="text-center text-white uppercase tracking-wider">
                        <PlayIcon className="mx-auto w-8 sm:w-10 h-8 sm:h-10 fill-current text-white" />
                        <div className="mt-1 text-xs">Start</div>
                      </div>
                    </button>
                  )}
                </div>

                <div className="flex space-x-3 mt-4 items-center">
                  <div className="w-full">
                    <div className="text-white border bg-white bg-opacity-30 border-white px-2 py-1 md:py-2 rounded-lg w-full text-sm md:text-base">
                      Durasi Rekam : {duration.show || "-"}
                    </div>
                  </div>
                  <div className="w-24 flex-shrink-0">
                    <Button
                      className="text-white border bg-white bg-opacity-30 border-white px-1 py-1 md:py-2 rounded-lg w-full text-sm md:text-base"
                      handleClick={() => setShowGraph(!showGraph)}
                    >
                      {showGraph ? "Lihat Data" : "Lihat Grafik"}
                    </Button>
                  </div>
                </div>

                {showGraph ? (
                  <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {PARAMS.BASIC.map((param, idx) => (
                      <div
                        className="border border-white rounded-xl shadow-lg px-2 py-2 relative"
                        style={{ backgroundColor: "#AACFD0" }}
                        key={"chart-" + idx}
                      >
                        <div className="absolute bg-primary text-white right-2 rounded text-xs w-10 text-center">
                          {value[param.key] || "-"}
                        </div>
                        <div className="h-32 text-xs">
                          <ChartLine
                            stroke={[COLOR.PRIMARY]}
                            data={data}
                            dataKeyX="idx"
                            dataKeyY={[param.key]}
                            yAxisLabel={param.key}
                            type="number"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="mt-5 grid grid-cols-12 gap-3">
                    {PARAMS.BASIC.map((param) => (
                      <div
                        className="col-span-6 xl:col-span-3 border border-white bg-secondary rounded-xl shadow-lg text-white px-2 md:px-4 py-3 relative"
                        style={{ minHeight: "4.2rem" }}
                        key={"param-basic-" + param.label}
                      >
                        <div className="text-base xl:text-lg">
                          {param.label}
                        </div>
                        <div className="text-white text-xs md:text-sm text-opacity-50">
                          {param.unit}{" "}
                        </div>
                        <div className="absolute right-3 text-xl md:text-3xl bottom-2">
                          {value[param.key] || "-"}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardDashboard>
              <div className="hidden lg:block">
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>

            <div className="col-span-12 lg:col-span-4">
              <CardDashboard
                icon={<Description fill={"#fafafa"} className="w-5 h-5" />}
                title="Rekam Medis"
              >
                {records.length === 0 ? (
                  <div className="mt-3">Tidak ada riwayat rekam medis.</div>
                ) : (
                  <table className="w-full mt-5 mb-3 text-sm">
                    <tbody>
                      {records.map((record, idx) => {
                        if (record._id === undefined)
                          return (
                            <tr className="" key={"dummy-record-" + idx}>
                              <td className="px-1 py-1">
                                <AnimatedBlock className="h-6" />
                              </td>
                              <td className="px-1 py-1">
                                <AnimatedBlock className="h-6" />
                              </td>
                              <td className="px-1 py-1">
                                <AnimatedBlock className="h-6" />
                              </td>
                            </tr>
                          );
                        return (
                          <tr
                            key={"record-" + record._id}
                            className={
                              "border-b cursor-pointer  " +
                              (idx === 0 ? "border-t " : "") +
                              (idx % 2 === 0
                                ? " bg-secondary bg-opacity-20"
                                : "")
                            }
                            onClick={() => {
                              history.push({
                                pathname: `/record/${record._id}`,
                                state: { prevPath: location.pathname },
                              });
                            }}
                          >
                            <td className="px-1 py-1 w-32">
                              {record.createdAt}
                            </td>
                            <td className="px-1 py-1">
                              {record.patient.user.name}
                            </td>
                            <td className="px-1 py-1">{`Tes ke-${record.testNumber}`}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </CardDashboard>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default DeviceDetail;
